import type { IDimensionDefinition } from '@feathr/blackbox';
import { getAspectRatioNotation } from '@feathr/blackbox';

import type { IAdDimensionOption } from './AdDimensionsSelect.types';

/**
 * Builds an array of dimension options from a dimensions record.
 *
 * @param dimensions - Record of dimension definitions keyed by size string
 * @param isMeta - Whether these are Meta (Facebook) dimensions
 * @returns Array of dimension options for use in select
 */
export function buildDimensionOptions(
  dimensions: Record<string, IDimensionDefinition>,
  isMeta: boolean,
): IAdDimensionOption[] {
  return Object.keys(dimensions).map<IAdDimensionOption>((key: string) => {
    const { height, name, spec, width } = dimensions[key];
    return {
      aspectRatio: getAspectRatioNotation(width / height),
      height,
      id: spec,
      isMeta,
      name,
      width,
    };
  });
}
